import React, { useCallback, useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import ActionDrawer from './ActionDrawer';
import ActionsWorkspace from './ActionsWorkspace';
import { ORGANIZATION } from './ICSConstants';
import { GetOrgActionResponse } from './hooks/orgActionHooks';
import { useCreateIntent } from 'components/MapPage/useCreateIntent';
import { ActionReminderPolicyButton } from './actionsTable/ActionReminderPolicyEditor';

const OrgActionsPage: React.FC = () => {
  const [showAddDrawer, setShowAddDrawer] = useState(false);
  const [selectedAction, setSelectedAction] =
    useState<GetOrgActionResponse | null>(null);

  useCreateIntent(
    'action',
    useCallback(() => setShowAddDrawer(true), [])
  );

  return (
    <div className="dark tw:text-foreground">
      <div className="tw:pb-2 tw:text-sm tw:font-medium">Tasks</div>
      <ActionsWorkspace
        scope={ORGANIZATION}
        storageKey="org-actions-view"
        onEditAction={setSelectedAction}
        toolbar={
          <div className="tw:flex tw:items-center tw:gap-2">
            <ActionReminderPolicyButton />
            <Button size="sm" onClick={() => setShowAddDrawer(true)}>
              <Plus className="tw:size-4" />
              Add Task
            </Button>
          </div>
        }
      />

      {showAddDrawer && (
        <ActionDrawer
          scope={ORGANIZATION}
          toggle={() => setShowAddDrawer(false)}
        />
      )}
      {selectedAction && (
        <ActionDrawer
          scope={ORGANIZATION}
          selectedEntity={selectedAction}
          toggle={() => setSelectedAction(null)}
        />
      )}
    </div>
  );
};

export default OrgActionsPage;
